/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import rest from '../../../../client/js/lib/rest'
import { stringify } from 'qs'
import { handleBlobResponse } from '../../../../client/js/lib/download'

export function downloadAgencyReportData (params?: Record<string, unknown>) {
  return rest.get(`/api/agency-reports/download?${stringify(params)}`)
    .then(handleBlobResponse)
}

export function fetchAgencyReportData (params?: Record<string, unknown>) {
  return rest.get(`/api/agency-reports/data?${stringify(params)}`)
    .then((resp) => resp.json())
}
